import React from 'react';
import PropTypes from 'prop-types';

import OrderAddress from './OrderAddress/OrderAddress';
import OrderItems from './OrderItems/OrderItems';
import OrderPayment from './OrderPayment/OrderPayment';

import { Col, Row, VertTypography } from '@vertem-core/vertice-ds';

import 'Assets/styles/default/components/Orders/OrderDetails/OrderDetailsStyles.less';

import { formatToBrazilianExtended } from 'Utils/commons/date';
import useSupplier from 'Hooks/useSupplier';

const OrderDetails = ({ order }) => {
  const { supplierWithoutShipping } = useSupplier(order?.vendorOrderModel);

  const isVirtualVoucher = order?.vendorOrderModel.some(
    ({ vendorType }) => vendorType == 'Voucher Virtual Externo',
  );

  const validShipping = order?.address && supplierWithoutShipping;

  return (
    <Col className='col col-auto'>
      <Row className='order-details-label' align='middle' gutter={6}>
        <Col className='col-5'>
          <VertTypography.Title>Sobre o pedido #{order.parentOrderId}</VertTypography.Title>
        </Col>
        <Col className='col'>
          <VertTypography.Paragraph>Pontos</VertTypography.Paragraph>
        </Col>
        {!isVirtualVoucher && supplierWithoutShipping ? (
          <Col className='col'>
            <VertTypography.Paragraph>Status</VertTypography.Paragraph>
          </Col>
        ) : (
          ''
        )}
        <Col className='col'>
          <Row justify='end' gutter={6} />
        </Col>
      </Row>

      <Row className='order-details-date' gutter={6}>
        <Col className='col'>
          <VertTypography.Paragraph>
            Pedido realizado em {formatToBrazilianExtended(order.createDate)}
          </VertTypography.Paragraph>
        </Col>
      </Row>

      <Row className='order-details-items ' gutter={{ lg: 6, xs: 0 }}>
        <OrderItems order={order} />
      </Row>

      {!isVirtualVoucher && validShipping ? (
        <Row className='order-details-address' gutter={6}>
          <OrderAddress shippingAddress={order.address} />
        </Row>
      ) : (
        ''
      )}

      <Row className='order-details-payment' gutter={6}>
        <OrderPayment order={order} />
      </Row>
    </Col>
  );
};

OrderDetails.propTypes = {
  order: PropTypes.array.isRequired,
};

export default OrderDetails;
